module.exports = __webpack_public_path__ + "img/GRI_Logo.0ca9c4a5.svg";